import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Container from "../Container";
import { useTheme } from "../../context/ThemeContext";

const Footer = () => {
  const { colors, isDark } = useTheme();
  const { t } = useTranslation("header");

  return (
    <>
      <footer className={`mt-16 text-center text-sm ${colors.text.muted}`}>
        <Container>
          <div className="px-2 flex flex-wrap justify-center gap-3 md:gap-4 text-xs my-2 ">
            <Link to="/" className="hover:underline">
              {t("home")}
            </Link>
            <Link to="/projects" className="hover:underline">
              {t("projects")}
            </Link>
            <Link to="/educations" className="hover:underline">
              {t("educations")}
            </Link>
            <Link to="/work-experiences" className="hover:underline">
              {t("work")}
            </Link>
            <Link to="/references" className="hover:underline">
              {t("references")}
            </Link>
            <Link to="/blogs" className="hover:underline">
              {t("blogs")}
            </Link>
            <Link to="/contact" className="hover:underline">
              {t("contact")}
            </Link>
            <Link to="/dashboard" className="hover:underline">
              {t("login")}
            </Link>
          </div>
        </Container>
      </footer>

      <div
        className={`text-center text-[10px] md:text-sm py-1 mt-1 ${
          isDark ? colors.background.primary : "bg-gray-200"
        } ${colors.text.muted}`}
      >
        © {new Date().getFullYear()} {t("title")}
      </div>
    </>
  );
};

export default Footer;
